import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SERVICES } from "../../data/content";
import { Reveal } from "./Reveal";

const MARBLE =
  "https://images.unsplash.com/photo-1558346648-9757f2fa4474?crop=entropy&cs=srgb&fm=jpg&w=1400&q=70";

export default function Services() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-primary text-primary-foreground overflow-hidden"
    >
      {/* Hover background texture */}
      <AnimatePresence>
        {active !== null && (
          <motion.div
            key={active}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.18 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
            className="absolute inset-0 bg-cover bg-center pointer-events-none"
            style={{ backgroundImage: `url(${MARBLE})` }}
          />
        )}
      </AnimatePresence>

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-mono-accent text-xs uppercase tracking-[0.22em] text-primary-foreground/60 mb-6">
                What I offer
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif-display font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
                POSH compliance, handled end&#8209;to&#8209;end.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <Reveal delay={0.1}>
              <p className="text-base md:text-lg leading-relaxed text-primary-foreground/70">
                From first training session to final inquiry report — a single,
                senior point of accountability for your workplace safety mandate.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.no}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              data-testid={`service-item-${i}`}
              className="group border-b border-primary-foreground/20 py-8 md:py-10 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline cursor-default"
            >
              <div className="md:col-span-1 font-mono-accent text-sm text-primary-foreground/50">
                {s.no}
              </div>
              <h3 className="md:col-span-5 font-serif-display text-3xl md:text-4xl leading-tight transition-transform duration-500 group-hover:translate-x-3">
                {s.title}
              </h3>
              <p className="md:col-span-5 md:col-start-8 text-sm md:text-base leading-relaxed text-primary-foreground/70">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
